import { render, staticRenderFns } from "./InfoSquareIcon.vue?vue&type=template&id=10e5bedf&"
import script from "./InfoSquareIcon.vue?vue&type=script&lang=js&"
export * from "./InfoSquareIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports